import Lenis from "lenis";

const LENIS_EXCLUDE_SELECTORS = [
    ".no-lenis", // manual opt-out
    ".gform_wrapper", // entire Gravity Form
    ".gform_page_fields", // multi-page step container
    ".gform-body", // inner GF scroll area
    ".mfp-wrap", // Magnific Popup
    ".modal", // generic modals
    ".popup", // generic popups
    "[data-lenis-prevent]", // future-proof custom hook
    ".woocommerce-checkout",
].join(",");

const isMobileTouch = window.matchMedia(
    "(hover: none) and (pointer: coarse)",
).matches;

const lenis = new Lenis({
    duration: 1.4,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: "vertical",
    gestureDirection: "vertical",
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: !isMobileTouch,
    touchMultiplier: 2,
    infinite: false,

    prevent: (node) => node.closest(LENIS_EXCLUDE_SELECTORS),
});

// RAF loop
function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}
requestAnimationFrame(raf);
